import { IDataRoom, IUserData } from 'interfaces';

const normalize = (name: string) => name?.trim().toLowerCase();

export const checkIsRoomNameExists = (
  roomName: string,
  allRooms: IDataRoom[],
  userData: IUserData | null,
  excludeRoomId?: string,
) => {
  if (!roomName || !allRooms?.length || !userData?.id) return false;

  const normalized = normalize(roomName);

  return allRooms
    .filter((room) => room.owner_id === userData.id)
    .filter((room) => (excludeRoomId ? room.id !== excludeRoomId : true))
    .some((room) => normalize(room.name) === normalized);
};

export default checkIsRoomNameExists;


